import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import appconst from '@/lib/appconst';


interface FontFlowAmountStatisticalState extends ListState<any> {
}

class FontFlowAmountStatisticalMutations extends ListMutations<any>{

}
class FontFlowAmountStatistical extends ListModule<FontFlowAmountStatisticalState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        shopid: 0

    }
    actions = {
        async getAll(context: ActionContext<FontFlowAmountStatisticalState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/StatisticalRecords/GetStatisticalConsumptionFlowListByUserId', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as Array<any>;
            context.state.totalCount = page.length;
            context.state.list = page;

        },
    };
    mutations = {
        setCurrentPage(state: FontFlowAmountStatisticalState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FontFlowAmountStatisticalState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const fontflowAmountStatistical = new FontFlowAmountStatistical();
export default fontflowAmountStatistical;